//angular imports
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

//local imports
import { 
  CatalogRoutingModule, 
  CatalogComponents,
  CatalogPages,
} from '@app/catalog';

import { SharedModule } from '@app/shared'
import { CatalogCommonModule } from '@app/catalog-common';
import { MsalModule } from '@azure/msal-angular';
import { AppCommonModule } from '@app/app-common';

@NgModule({
  declarations: [...CatalogPages, ...CatalogComponents],
  imports: [
    CommonModule, 
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    AppCommonModule,
    CatalogCommonModule,
    CatalogRoutingModule, 
    SharedModule,
    MsalModule
  ]
})
export class CatalogModule {
      constructor() {}
 }
